export default __webpack_public_path__ + "static/nfl-new-orleans-saints-team-logo-82eb229dc7a0f10de60109f465e5f1d3.svg";